module.exports = __webpack_public_path__ + "static/media/SettingsIconActive.1803d909.png";